import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from "vuex-persist";
Vue.use(Vuex);
//持久化设定
const vuexLocal = new VuexPersistence({
    storage: window.localStorage,
    reducer(val) {

    }
});
let store = new Vuex.Store({
    state: {
        token: '', //用户是否登录
        userInfo: null,//用户信息
        picUrl: '/dataImg/',
        fileUrl: '',
        resultFileUrl:''
    },
    getters: {

    },
    mutations: {

    },
    plugins: [vuexLocal.plugin], //持久化插件  npm install vuex-persist -D
});

export default store;